import { parse } from 'url';
import axios from 'axios';
import qs from 'qs';
import * as _ from 'lodash';

import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { connect } from 'react-redux';

import googleUrlImg from '../../../images/googleLogo-48px.png';

import {
  GOOGLE_AUTHORIZATION_URL,
  GOOGLE_VALIDATE_TOKEN_URL,
  GOOGLE_REDIRECT_URI,
  GOOGLE_CLIENT_ID,
  GOOGLE_PROFILE_URL
} from '../../../config_module';

import { requireFromElectron } from '../../../services/crossPlatform/crossPlatformService';

const electron = requireFromElectron('electron');

class LoginGoogleButtonElectron extends React.Component {
  constructor(props) {
    super(props);
    this.handleSignIn = this.handleSignIn.bind(this);
  }

  static propTypes = {
    onSuccess: PropTypes.func.isRequired,
    onFailure: PropTypes.func.isRequired
  };

  handleSignIn() {
    return googleSignIn(this.props.onSuccess, this.props.onFailure);
  }

  render() {
    return (
      <button className="sso-login" onClick={this.handleSignIn}>
        <img src={googleUrlImg} alt="presentation" />
        <span>{I18n.t('login.googleLogin')}</span>
      </button>
    );
  }
}
export default connect()(LoginGoogleButtonElectron);

/**/

async function googleSignIn(onSuccess, onFailure) {
  try {
    const token = await signInWithPopup();
    // const tokens = await fetchAccessTokens(code);
    const validToken = await validateGoogleToken(token);

    if (validToken) {
      const googleProfile = await fetchGoogleProfile(token);
      const userProfile = getUserProfile(googleProfile, token);
      return onSuccess(userProfile);
    }

    return onFailure();
  } catch (error) {
    return onFailure();
  }
}

function getUserProfile(googleResponse, accessToken) {
  let googleProfile = {
    email: googleResponse.email,
    givenName: googleResponse.given_name,
    familyName: googleResponse.family_name,
    imageUrl: googleResponse.picture,
    accessToken: accessToken
  };

  return googleProfile;
}

function signInWithPopup() {
  return new Promise((resolve, reject) => {
    const urlParams = {
      response_type: 'token',
      redirect_uri: GOOGLE_REDIRECT_URI,
      client_id: GOOGLE_CLIENT_ID,
      scope: 'profile email',
      prompt: 'select_account'
    };

    const authUrl = `${GOOGLE_AUTHORIZATION_URL}?${qs.stringify(urlParams)}`;
    return openElectronWindow(authUrl, resolve, reject);
  });
}

async function validateGoogleToken(token) {
  const data = qs.stringify({
    access_token: token
  });

  const config = {
    method: 'post',
    url: GOOGLE_VALIDATE_TOKEN_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data,
    preventInterceptors: true
  };

  const response = await axios(config);

  const hasError = _.has(response.data, 'error');
  if (hasError) return false;

  const matchApp = _.has(response.data, 'aud') && response.data.aud === GOOGLE_CLIENT_ID;
  if (!matchApp) return false;

  return true;
}

async function fetchGoogleProfile(accessToken) {
  const response = await axios.get(GOOGLE_PROFILE_URL, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    preventInterceptors: true
  });
  return response.data;
}

function openElectronWindow(authUrl, resolve, reject) {
  const { BrowserWindow } = electron.remote;

  const authWindow = new BrowserWindow({
    width: 500,
    height: 600,
    show: true,
    webPreferences: {
      devTools: true,
      'web-security': false
    }
  });

  function handleNavigation(url) {
    let hash = parse(url, true).hash;
    if (hash) {
      hash = hash.replace('#', '');

      const response = qs.parse(hash);
      if (response.error) {
        reject(new Error(`There was an error: ${response.error}`));
      } else if (response.access_token) {
        // Login is complete
        authWindow.removeAllListeners('closed');
        setImmediate(() => authWindow.close());

        // This is the authorization code we need to request tokens
        resolve(response.access_token);
      }
    }
  }

  authWindow.on('closed', () => {});

  authWindow.webContents.on('will-navigate', (event, url) => {
    handleNavigation(url);
  });

  authWindow.webContents.on('will-redirect', (event, url) => {
    if (url.includes(GOOGLE_REDIRECT_URI)) {
      handleNavigation(url);
    }
  });

  authWindow.loadURL(authUrl);
}
